<template lang="pug">
  .dashboard-view
    v-container.pa-0(style="max-width:600px")
      v-card.d-flex.align-center.mt-4.pa-3(v-if="potentialSales" flat text :style="[{'background-color': $vuetify.theme.themes[$theme].info500}, { 'border-radius' : $vuetify.breakpoint.xsOnly ? '0px' : '' }]" @click="$router.push('/admin/follow-up?range=yesterday')")
        CashIcon.ma-auto(size="22" :style="{ 'color': $vuetify.theme.themes[$theme].basic300 }")
        div.c1.basic300--text.ml-2 {{ $t('followUpBanner.follow_up_message') }}
        v-spacer
        v-btn.button-Aa-small.pa-0.ml-3(color="transparent" text small)
          div.white--text {{ potentialSales.potential_sales | displayPrice }} ({{ potentialSales.total_leads }} {{ $t('followUpBanner.leads') }})
      v-card.mt-4.pa-3(v-if="showAffiliate && $currency.code == 'MYR'" flat text :style="[{'background-color': $vuetify.theme.themes[$theme].zooPurple}, { 'border-radius' : $vuetify.breakpoint.xsOnly ? '0px' : '' }]")
        div.label.white--text.text-uppercase {{ $t('affiliateBanner.title') }}
        div.c1.white--text.mt-1 {{ $t('affiliateBanner.description') }}
        v-btn.button-Aa-small.white--text.px-0.mt-1(text small @click="openRegAffiliateDialog = true") {{ $t('affiliateBanner.register') }}
          eva-icon.ml-1.mt-1(name="arrow-forward-outline" fill="white" width="15" height="15")
      v-card.mt-4.pa-4(v-if="survey.show" flat text :style="[{'background-color': $vuetify.theme.themes[$theme].zooPurpleT10}, { 'border-radius' : $vuetify.breakpoint.xsOnly ? '0px' : '' }]")
        div.c1.zooPurple--text {{ survey.description }}
        div.c2.zooPurple--text.clickable.mt-1(@click="clickOpenSurvey(survey.url)") {{ survey.buttonText }}
      v-alert.mt-4(v-if="yezzaTrial.value || yBooksTrial.value" :style="{'color': $vuetify.theme.themes[$theme].info500}" text)
        v-row(align='center' dense)
          v-col.pa-0.mr-4.shrink
            eva-icon(name="clock-outline" :fill="$vuetify.theme.themes[$theme].info500")
          v-col.pa-0.grow
            .c1.info500--text(v-if="yezzaTrial.value") {{ $t('yezzaTrialBanner.yezza_trial') }}
              span.c2.info500--text  {{ yezzaTrial.data.end_date | displayDate }}
            .c1.info500--text(v-if="yBooksTrial.value") {{ $t('yezzaTrialBanner.yezza_books_trial') }}
              span.c2.info500--text  {{ yBooksTrial.data.end_date | displayDate }}
          v-col.pa-0.shrink(v-if="yezzaTrial.value || yBooksTrial.value")
            v-btn.px-2(v-if="yezzaTrial.value && yBooksTrial.value" color="info500" outlined small depressed :style="{'background-color':$vuetify.theme.themes[$theme].infoT08}" @click="$router.push('/admin/billing/subscription')")
              .button-AA-tiny.info500--text {{ $t('yezzaTrialBanner.view') }}
            v-btn.px-2(v-else-if="yezzaTrial.value" color="info500" outlined small depressed :style="{'background-color':$vuetify.theme.themes[$theme].infoT08}" @click="showSubscribeModal = true")
              .button-AA-tiny.info500--text {{ $t('yezzaTrialBanner.subscribe') }}
            v-btn.px-2(v-else-if="yBooksTrial.value" color="info500" outlined small depressed :style="{'background-color':$vuetify.theme.themes[$theme].infoT08}" @click="showSubscribeBookModal = true")
              .button-AA-tiny.info500--text {{ $t('yezzaTrialBanner.subscribe') }}
      v-alert.mt-4(v-if="!yBooksTrial.value && !yBooksSubscription.value && company.primary_owner === member.id" color='info500' text)
        div.d-flex.align-center
          div
            div.h6.info500--text {{ $t('yezzaBooksBanner.title') }}
            div.p2.info400--text {{ $t('yezzaBooksBanner.description') }}
          v-spacer
          v-btn.px-2.button-AA-tiny.basic100--text(small depressed :style="{'background-color': $vuetify.theme.themes[$theme].info500}" @click="showBooksIntroModal = true") {{ $t('yezzaBooksBanner.button') }}
      v-alert.mt-4(v-if="show1010Offer" color='accent' text)
        v-row(align='center' dense)
          v-col.pa-0.mr-4.shrink
            v-icon(color="accent") mdi-sale
          v-col.pa-0.grow
            div.body-2.font-weight-bold 10.10 Yezza Combo (12-months subscription discount + free domain)
            div.caption Offer ends in {{ offer1010SecondsLeft | countdown }}
          v-col.pa-0.shrink
            v-btn.ml-1(color="textColorAccent" @click="openOffer1010Modal" small) Grab now
      .billing-warning(v-if="member && member.id === company.primary_owner")
        pending-payments(:company="company")
      yezza-pay-notice(:company="company")

      .stats(v-if="Auth('component', '/admin/dashboard#statistics')")
        v-row.mt-2.mb-0(no-gutters)
          v-col(cols="12")
            v-row.justify-center(no-gutters)
              v-col(cols="4")
                v-card.ma-2.text-center(height="60px" flat)
                  .h6.primary500--text {{ $store.state.ui.pendingOrderCount ? $store.state.ui.pendingOrderCount : '-' }}
                  .p2.textColorHint--text.mt-1 {{ $t('statistic.order_to_fulfill') }}
              v-col(cols="4")
                v-card.ma-2.text-center(height="60px" flat)
                  .h6.primary500--text {{ $store.state.ui.unitsSoldToday ? $store.state.ui.unitsSoldToday : '-' }}
                  .p2.textColorHint--text.mt-1 {{ $t('statistic.unit_sold') }}
              v-col(cols="4")
                v-card.ma-2.text-center(height="60px" flat)
                  .h6.primary500--text {{ $store.state.ui.closedLeadsToday ? $store.state.ui.closedLeadsToday : '-' }}
                  .p2.textColorHint--text.mt-1 {{ $t('statistic.customer_today') }}

      //- .stats(v-else-if="member.role === 'Admin'")
        v-row.mt-2.mb-0(no-gutters)
          v-col(cols="12")
            v-row.justify-center(no-gutters)
              v-col(cols="4")
                v-card.ma-2.text-center(height="60px" flat)
                  .h6.primary500--text {{ $store.state.ui.newLeadsToday ? $store.state.ui.newLeadsToday : '-' }}
                  .p2.textColorHint--text.mt-1 New leads today
              v-col(cols="4")
                v-card.ma-2.text-center(height="60px" flat)
                  .h6.primary500--text {{ $store.state.ui.closedLeadsToday ? $store.state.ui.closedLeadsToday : '-' }}
                  .p2.textColorHint--text.mt-1 Number of Donors today

      dashboard-quick-actions(v-if="Auth('component', '/admin/dashboard#books_quick_action')" @added="incomeOrExpenseUpdate++")
      sales-and-profit-chart(v-if="Auth('component', '/admin/dashboard#sales_chart') && Auth('component', '/admin/dashboard#profit_chart')" :company="company" :update.sync="incomeOrExpenseUpdate")
      sales-chart(v-else-if="Auth('component', '/admin/dashboard#sales_chart')" :company="company")
      profit-chart(v-else-if="Auth('component', '/admin/dashboard#profit_chart')" :company="company" :update.sync="incomeOrExpenseUpdate")
      agent-sales-chart(v-if="Auth('component', '/admin/dashboard#agent_sales_chart')" :company="company" :agent="agentData")
      //- donation-chart(v-if="member.role === 'Admin' && $store.state.subscriptions.feature=== 'free'" :company="company")

      v-row.mb-4(no-gutters)
        v-col.mt-6(v-if="Auth('component', '/admin/dashboard#unpaid_invoices')" cols="12")
          dashboard-unpaid-invoices.mx-1(:company="company" :update.sync="incomeOrExpenseUpdate")
        v-col.mt-6(v-if="Auth('component', '/admin/dashboard#quick_links')" cols="12")
          ac-dashboard-quick-links.mx-1(v-if="agentData  && member.role === 'Agent' && company.id == $store.state.constants.AC_COMPANY_ID" :company="company")
          dashboard-quick-links.mx-1(v-else :company="company")
        v-col.mt-6(v-if="Auth('component', '/admin/dashboard#referral_program')" cols="12")
          referral-info.mx-4
        v-col.mt-6(cols="12")
          dashboard-products.mx-1(:company="company")

    .modals
      subscribe-1010-modal(v-if="showSubscribe1010Modal" :open.sync="showSubscribe1010Modal" :company="company" :skippable="true" :payment="offer1010Payment")
      subscribe-modal(v-if="showSubscribeModal" :open.sync="showSubscribeModal" :offer="offer" :company="company" :volunteer="true" @subscribed="$store.commit('subscriptions/update')" :paymentCallback="subscriptionPaymentCallback")
      subscribe-book-modal(v-if="showSubscribeBookModal" :open.sync="showSubscribeBookModal" :company="company" :volunteer="true" @subscribed="$store.commit('subscriptions/update')")
      subscribe-referral-modal(v-if="showSubscribeReferralModal" :open.sync="showSubscribeReferralModal"  :offer="offer" :company="company" :volunteer="true" @subscribed="company.status = 'Active'"  :paymentCallback="subscriptionPaymentCallback")
      subscribe-70-modal(v-if="showSubscribe70Modal" :open.sync="showSubscribe70Modal" :company="company" :skippable="true")
      books-intro-modal(:open.sync="showBooksIntroModal" :company="company" @try="startTrial('YBOOKS_NORMAL_TRIAL')")
      y-dialog(v-if="openRegAffiliateDialog" v-model='openRegAffiliateDialog', max-width='320')
        v-card
          v-card-title.h6.basic800--text.px-4 {{ $t('affiliateDialog.title') }}
          v-card-text.p2.primary500--text.px-4.py-0
            y-checkbox(v-model="understandAffiliate")
              template(v-slot:label)
                div.p2 {{ $t('affiliateDialog.tnc_1') }}
                  a.info500--text.font-weight-bold(href="https://yezza.com/affiliate-terms-condition" target="_blank") {{ $t('affiliateDialog.tnc_2') }}
            y-checkbox(v-model="agreeAffiliate")
              template(v-slot:label)
                div.p2 {{ $t('affiliateDialog.agree') }}
          v-card-actions
            v-spacer
            v-btn(color='white', text @click='openRegAffiliateDialog = false')
              .button-Aa-small.primary400--text {{ $t('affiliateDialog.cancel') }}
            v-btn.mr-2.button-AA-small(color='info500' depressed height=32 @click='registerAffiliate()' :loading="isLoading" :disabled="!understandAffiliate || !agreeAffiliate")
              div(:class="{ 'basic100--text' : understandAffiliate && agreeAffiliate }") {{ $t('affiliateDialog.register') }}

</template>

<script>
import { mapState, mapActions } from 'vuex'
import { DateTime, Duration } from 'luxon'
import SubscribeModal from '@/components/billing/SubscribeModal.vue'
import SubscribeBookModal from '@/components/billing/SubscribeBookModal.vue'
import Subscribe70Modal from '@/components/billing/Subscribe70Modal.vue'
import Subscribe1010Modal from '@/components/billing/Subscribe1010Modal.vue'
import SubscribeReferralModal from '@/components/billing/SubscribeReferralModal.vue'
import BooksIntroModal from '@/components/billing/BooksIntroModal.vue'
import PendingPayments from '@/components/billing/PendingPayments.vue'
import DashboardQuickActions from '@/components/dashboard/DashboardQuickActions.vue'
import DashboardQuickLinks from '@/components/dashboard/DashboardQuickLinks.vue'
import AcDashboardQuickLinks from '@/components/dashboard/AcDashboardQuickLinks.vue'
import DashboardProducts from '@/components/dashboard/DashboardProducts.vue'
import DashboardUnpaidInvoices from '@/components/dashboard/DashboardUnpaidInvoices.vue'
import SalesAndProfitChart from '@/components/analytics/SalesAndProfitChart.vue'
import SalesChart from '@/components/analytics/SalesChart.vue'
import AgentSalesChart from '@/components/analytics/AgentSalesChart.vue'
import DonationChart from '@/components/analytics/DonationChart.vue'
import ProfitChart from '@/components/analytics/ProfitChart.vue'
import ReferralInfo from '@/components/ReferralInfo'
import YezzaPayNotice from '@/components/dashboard/YezzaPayNotice'

export default {
  name: 'Dashboard',
  components: {
    ReferralInfo,
    SubscribeModal,
    SubscribeBookModal,
    Subscribe70Modal,
    Subscribe1010Modal,
    SubscribeReferralModal,
    BooksIntroModal,
    PendingPayments,
    DashboardQuickActions,
    DashboardQuickLinks,
    AcDashboardQuickLinks,
    DashboardProducts,
    SalesAndProfitChart,
    SalesChart,
    DonationChart,
    ProfitChart,
    DashboardUnpaidInvoices,
    AgentSalesChart,
    YezzaPayNotice
  },
  props: ['company', 'menu'],
  data: () => ({
    offer: false,
    daysRegistered: null,
    showSubscribeModal: false,
    showSubscribeBookModal: false,
    offerSecondsLeft: 0,
    subscribe70GrabLoading: false,
    showSubscribe70Modal: false,
    subscribe70SecondsLeft: 0,
    showSubscribe1010Modal: false,
    showSubscribeReferralModal: false,
    showBooksIntroModal: false,
    offer1010SecondsLeft: 0,
    offer1010Payment: false,
    subscriptionPaymentCallback: null,
    hasreferralCode: null,
    agentData: null,
    incomeOrExpenseUpdate: 0,
    survey: {
      show: false,
      description: 'We are launching the new Order management soon. Be the first to try it before our official release.',
      buttonText: 'Apply for beta access',
      url: 'https://yezzaio.typeform.com/to/jw7qUs90'
    },
    showAffiliate: false,
    understandAffiliate: false,
    agreeAffiliate: false,
    openRegAffiliateDialog: false,
    potentialSales: null,
    isLoading: false
  }),
  computed: {
    ...mapState('subscriptions', ['yezzaTrial', 'yezzaSubscription', 'yBooksTrial', 'yBooksSubscription', 'genesData']),
    ...mapState('user', ['member']),
    showOffer () {
      if (this.offerSecondsLeft > 0 && this.yezzaTrial.value && this.daysRegistered <= 6 && this.subscribe70SecondsLeft === 0) {
        return true
      } else {
        return false
      }
    },
    show1010Offer () {
      var end = new Date(2020, 9, 10 , 23, 59)
      var now = new Date()
      if (this.company.status !== 'Active' && now < end && this.company.campaign && this.company.campaign.promo1010) {
        return true
      } else {
        return false
      }
    },
    show70PercentOffer () {
      if (this.subscribe70SecondsLeft > 0 && this.company.status === 'Trial') {
        return true
      } else {
        return false
      }
    }
  },
  watch: {
    showOffer (val) {
      if (val) {
        this.checkYearlySubscriptionPayment()
      }
    },
    show1010Offer: {
      immediate: true,
      handler (val) {
        if (val) {
          var end = new Date(2020, 9, 10 , 23, 59);
          this.offer1010SecondsLeft = (end - new Date()) / 1000
          const interval = setInterval(() => {
            this.offer1010SecondsLeft--
            if (this.offer1010SecondsLeft <= 0) {
              clearInterval(interval)
            }
          }, 1000)
        }
      }
    },
    genesData () {
      this.checkOsType()
    }
  },
  mounted () {
    this.fetchDaysRegistered()
    this.fetchDashboardCount()
    // this.fetchSubsidy70FirstSeenDate()
    this.checkOffer1010Payment()
    this.checkReferralCode()
    this.fetchAgentData()
    this.checkAffiliation()
    this.getPotentialSales()

    // Show subscribe modal after clicking "Subscribe Now" button in NEMO notification
    if (this.$store.state.ui.showSubscribeModal) {
      if (this.showOffer) {
        this.showMessage(['error', this.$t('error_message.sorry_this_offer_ended')])
      } else {
        this.offer = true
        this.showSubscribeModal = true
      }
      this.$store.commit('ui/setShowSubscribeModal', false)
    }
  },
  methods: {
    ...mapActions([
      'showMessage'
    ]),
    checkOsType () {
      if (this.genesData.find(f => f.feature === 'YD_FREE')) {
        this.$router.push('/admin/donation/analytics')
      } else if (this.genesData.find(f => f.feature === 'YZ_CLINIC')) {
        this.$router.push('/admin/clinic/appointment')
      } else if (this.genesData.find(f => f.feature === 'YZ_REVIEW')) {
        this.$router.push('/admin/review/review')
      }
    },
    fetchDashboardCount () {

      this.$axios.get(`/leads/?page=1&page_size=0&form__company=${this.company.id}&range=today`).then((response) => {
        this.$store.commit('ui/setNewLeadsToday', response.data.count)
      }).catch(() => {})

      this.$axios.get(`/companies/${this.company.id}/charts?span=day`).then((response) => {
        this.$store.commit('ui/setUnitsSoldToday', response.data['products']['total'])
      }).catch(() => {})

      this.$axios.get(`/leads/?page=1&page_size=0&form__company=${this.company.id}&range=today&status=processed&status=shipped&status=received&status=partial_payment`).then((response) => {
        this.$store.commit('ui/setClosedLeadsToday', response.data.count)
      }).catch(() => {})
    },
    fetchDaysRegistered () {
      this.$axios.get(`/companies/${this.company.id}/days_registered/`)
      .then(resp => {
        this.daysRegistered = resp.data.days
        if (this.daysRegistered <= 6) {
          let local = DateTime.local()
          let myTime = local.setZone('Asia/Kuala_Lumpur')
          let myTimeTomorrow = myTime.plus({ days: 7 - this.daysRegistered })
          myTimeTomorrow =  DateTime.local(myTimeTomorrow.year, myTimeTomorrow.month, myTimeTomorrow.day, 0, 0)
          myTimeTomorrow = myTimeTomorrow.setZone('Asia/Kuala_Lumpur', { keepLocalTime: true })
          let diffSeconds = Math.round(myTimeTomorrow.diff(myTime, 'seconds').toObject().seconds)
          this.offerSecondsLeft = diffSeconds
          let timer = setInterval(() => {
            this.offerSecondsLeft--
            if (this.offerSecondsLeft === 0) {
              clearInterval(timer)
            }
          }, 1000)
        }
      })
      .catch(() => {})
    },
    fetchSubsidy70FirstSeenDate () {
      this.$axios.get(`/companies/${this.company.id}/?extra_data=smeb40_first_seen_date`)
        .then(resp => {
          let firstSeenDate = resp.data['smeb40_first_seen_date']
          if (!firstSeenDate) {
            firstSeenDate = DateTime.local()
            firstSeenDate = firstSeenDate.setZone('Asia/Kuala_Lumpur')
            this.$axios.patch(`/companies/${this.company.id}/`, { extra_data: { smeb40_first_seen_date: firstSeenDate } })
          } else {
            firstSeenDate = DateTime.fromISO(firstSeenDate)
          }
          let myTimeEndDate = firstSeenDate.plus({ days: 4 })
          myTimeEndDate =  DateTime.local(myTimeEndDate.year, myTimeEndDate.month, myTimeEndDate.day, 0, 0)
          myTimeEndDate = myTimeEndDate.setZone('Asia/Kuala_Lumpur', { keepLocalTime: true })
          let local = DateTime.local()
          let myTime = local.setZone('Asia/Kuala_Lumpur')
          let diffSeconds = Math.round(myTimeEndDate.diff(myTime, 'seconds').toObject().seconds)
          if (diffSeconds < 0) return
          this.subscribe70SecondsLeft = diffSeconds
          let timer = setInterval(() => {
            this.subscribe70SecondsLeft--
            if (this.subscribe70SecondsLeft === 0) {
              clearInterval(timer)
            }
          }, 1000)
        })
        .catch(() => {})
    },
    fetchAgentData () {
      if (this.company.id == this.$store.state.constants.AC_COMPANY_ID) {
        this.$axios.get('/agent/agents/', { params: { member__company: this.company.id }})
          .then(resp => {
            if (resp.data.results.length > 0) {
              this.agentData = resp.data.results[0]
            }
          })
      }
    },
    checkReferralCode () {
      this.$axios.get(`/companies/${this.company.id}/used_referral_code/`)
      .then(resp => {
        this.hasreferralCode = resp.data['code']
        console.log(this.hasreferralCode)
      }).catch(() => {})
    },
    getPotentialSales () {  
      let url = `/leads/sales_recovery/summary?range=yesterday&company=${this.company.id}`
      if (this.member.role !== 'Admin') {
        url += `&member=${this.member.id}`
      }
      this.$axios.get(url)
        .then(resp => {
          this.potentialSales = resp.data
        })
    },
    checkSubscribe70Eligibility () {
      this.subscribe70GrabLoading = true
      this.$axios.get('/companies/', { page_size: -1, is_company_admin: true })
      .then(resp => {
        if (resp.data.results.filter(c => (c.plan.includes('SME Subsidy')
          || c.plan.includes('B40 Subsidy'))
          && c.status === 'Active').length > 0
        ) {
          this.showMessage(['error', this.$t('error_message.sorry_company_subsidised')])
        } else {
          this.showSubscribe70Modal = true
        }
      })
      .catch(() => {})
      .finally(() => {
        this.subscribe70GrabLoading = false
      })
    },
    openOffer1010Modal () {
      this.showSubscribe1010Modal = true
      this.$axios.patch(`/companies/${this.company.id}`, { extra_data: { 'campaign:promo1010.subscribe_modal_opened': new Date() }}).catch(() => {})
    },
    checkOffer1010Payment () {
      if (this.$route.query.status == 'promo1010_payment_success') {
        this.offer1010Payment = { success: true, billId: this.$route.query.bill_id }
        this.showSubscribe1010Modal = true
      } else if (this.$route.query.status == 'promo1010_payment_failed') {
        this.offer1010Payment = { success: false, billId: this.$route.query.bill_id }
        this.showSubscribe1010Modal = true
      }
    },
    checkYearlySubscriptionPayment () {
      console.log('checkYearlySubscriptionPayment', this.$route.query.status)
      if (this.$route.query.status == 'yearly_subscription_payment_success') {
        this.subscriptionPaymentCallback = { success: true, billId: this.$route.query.bill_id }
        this.showSubscribeModal = true
      } else if (this.$route.query.status == 'yearly_subscription_payment_failed') {
        console.log('retry')
        this.subscriptionPaymentCallback = { success: false, billId: this.$route.query.bill_id }
        this.showSubscribeModal = true
      }
    },
    startTrial (contract) {
      this.isLoading = true
      const subscription = {
        company: this.company.id,
        contract: contract
      }
      if (subscription.contract === 'YBOOKS_NORMAL_TRIAL') {
        subscription.add_ons = [{ feature: 'YBOOKS_REMINDER', count: 1 }]
      }
      this.$axios.post(`/subscription/subscriptions/`, subscription)
        .then(() => {
          this.$store.commit('subscriptions/update')
        })
        .catch(() => {})
        .finally(() => {
          this.isLoading = false
        })
    },
    clickOpenSurvey (url) {
      window.open(url)
    },
    launchAffiliate () {
      this.$router.push('/affiliate/dashboard')
    },
    checkAffiliation () {
      this.$axios.get('/partners/')
        .catch(() => {
          this.showAffiliate = true
        })
    },
    registerAffiliate () {
      this.isLoading = true
      this.$axios.post(`/partners/`)
        .then(() => {
          this.openRegAffiliateDialog = false
          this.launchAffiliate()
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isLoading = false
        })
    },
  },
  filters: {
    countdown (secondsLeft) {
      if (!secondsLeft) {
        return ''
      }
      let duration = Duration.fromObject({ seconds: secondsLeft })
      const [days, hours, minutes, seconds] = duration.toFormat('d:h:m:s').split(':')
      if (days == 0) {
        if (hours == 0) {
          if (minutes == 0) {
            return `${seconds}s`
          } else {
            return `${minutes}m ${seconds}s`
          }
        } else {
          return `${hours}h ${minutes}m ${seconds}s`
        }
      } else {
        return `${days}d ${hours}h ${minutes}m ${seconds}s`
      }
    }
  }
}
</script>

<style>
  .v-sheet--offset {
    top: -24px;
    position: relative;
  }
  div.v-picker__title {
    height: 0;
    padding: 0;
  }
</style>

<style lang="scss">
</style>

<i18n>
{
  "en": {
    "followUpBanner": {
      "follow_up_message": "Follow up potential sales from yesterday",
      "leads": "leads"
    },
    "affiliateBanner": {
      "title": "want to stop paying your subscription?",
      "description": "Refer businesses to use Yezza & earn up to RM 200 per new merchant with our new affiliate program.",
      "register": "Register as affiliate now"
    },
    "yezzaTrialBanner": {
      "yezza_trial": "Your Yezza trial will end on",
      "yezza_books_trial": "Your Books trial will end on",
      "view": "View",
      "subscribe": "Subscribe now"
    },
    "yezzaBooksBanner": {
      "title": "Yezza Books",
      "description": "Easy & automate accounting software",
      "button": "TELL ME MORE"
    },
    "statistic": {
      "order_to_fulfill": "Orders to fulfill",
      "unit_sold": "Units sold today",
      "customer_today": "Customers today"
    },
    "affiliateDialog": {
      "title": "Register Affiliate",
      "tnc_1": "I read and understand the ",
      "tnc_2": "Yezza Affiliate terms & condition",
      "agree": "I agree and want to register as Yezza Affiliate",
      "cancel": "Cancel",
      "register": "Register"
    }
  },
  "ms": {
    "follow_up_message": "Follow up potential sales from yesterday",
    "leads": "leads",
    "order_to_fulfill": "Orders to fulfill",
    "unit_sold": "Units sold today",
    "customer_today": "Customers today"
  },
  "id": {
    "followUpBanner": {
      "follow_up_message": "Tindak lanjut untuk penjualan potensial hari kemarin",
      "leads": "leads"
    },
    "affiliateBanner": {
      "title": "ingin berhenti membayar langganan kamu?",
      "description": "Referensikan bisnis untuk menggunakan Yezza & dapatkan hingga RM 200 per pedagang baru dengan program afiliasi baru kami.",
      "register": "Daftar sebagai afiliasi sekarang"
    },
    "yezzaTrialBanner": {
      "yezza_trial": "Akun Trial akan berakhir pada",
      "yezza_books_trial": "Akun Trial akan berakhir pada",
      "view": "Lihat",
      "subscribe": "Berlangganan"
    },
    "yezzaBooksBanner": {
      "title": "Yezza Books",
      "description": "Easy & automate accounting software",
      "button": "TELL ME MORE"
    },
    "statistic": {
      "order_to_fulfill": "Order",
      "unit_sold": "Produk terjual",
      "customer_today": "Pelanggan"
    },
    "affiliateDialog": {
      "title": "Daftar afiliasi",
      "tnc_1": "Saya sudah membaca dan mengerti ",
      "tnc_2": "Yezza Affiliatesyarat & ketentuan",
      "agree": "Saya setuju dan ingin mendaftar sebagai Yezza Affiliate",
      "cancel": "Batal",
      "register": "Daftar"
    }
  }
}
</i18n>
